import React from "react";
import styled from "styled-components";
import { MIN_MORNITOR_WIDTH } from "../../constants";

const LogoImageWrapper: React.FC = ({ children }) => {
  return <StyledImageWrapper>{children}</StyledImageWrapper>;
};

export default LogoImageWrapper;
const StyledImageWrapper = styled.div`
  min-width: 100%;
  height: 70%;
  @media only screen and (max-width: ${MIN_MORNITOR_WIDTH}) {
    display: none;
    height: 0;
  }
`;
